export const homeTabNames = ['manage-badges', 'badge-templates'];
export const badgeDetailsTabNames = ['assigned-accounts', 'history'];
export const searchParamKeyTab = 'tab';
export const searchParamKeyFilter = 'filter';
/**
 * Routing util for <ManageBadgesPanel>
 *
 * Beware:
 *  * root "badges/*" route is not part of <ManageBadgesPanel>, it's part of the doc and should not be part of this routing util
 */
export const manageBadgesRoutes = {
    home: (tabName, options) => addBasePrefix(tabName ? `?${searchParamKeyTab}=${tabName}` : '', options),
    createBadge: (templateId, options) => addBasePrefix(templateId ? `create/${templateId}` : 'create', options),
    duplicateBadge: (badgeId, options) => addBasePrefix(`duplicate/${badgeId}`, options),
    badgeDetails: (badgeId, tabName, options) => addBasePrefix(tabName ? `${badgeId}?${searchParamKeyTab}=${tabName}` : '', options),
};
function addBasePrefix(path, options) {
    return (options === null || options === void 0 ? void 0 : options.base) ? `${options.base}${path}` : path;
}
